/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseTokenResponseData } from './genericApiResponseTokenResponseData';
import type { GenericApiResponseTokenResponseMessage } from './genericApiResponseTokenResponseMessage';
import type { GenericApiResponseTokenResponsePagination } from './genericApiResponseTokenResponsePagination';
import type { GenericApiResponseTokenResponseError } from './genericApiResponseTokenResponseError';

export interface GenericApiResponseTokenResponse {
  data?: GenericApiResponseTokenResponseData;
  message?: GenericApiResponseTokenResponseMessage;
  pagination?: GenericApiResponseTokenResponsePagination;
  error?: GenericApiResponseTokenResponseError;
  statusCode?: number;
}
